<form>
    <app-form-section [formGroup]="periodForm">
        <app-form-row-header
            [title]="'FEATURES.AGREEMENTS.GROUP_TITLE_CONTRACT_DATES' | translate"
            icon="calendar_today"
        />

        <!-- Timeline Component -->
        <app-agreement-timeline
            [validFrom]="f.validFrom.value"
            [noticeDate]="noticeDate"
            [validTo]="f.validTo.value"
            [terminationDate]="f.terminationDate.value"
            [validToAfterExtension]="validToAfterExtension"
        ></app-agreement-timeline>

        <div class="form">
            <app-form-row>
                <app-form-group>
                    <label for="validFrom"
                        >{{ 'FEATURES.AGREEMENTS.VALIDFROM' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.ValidFrom" />
                        <span
                            *ngIf="!isNotInventory()"
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.INVENTORY_VALIDFROM' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-date-picker
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        formControlName="validFrom"
                        (changed)="validFromChanged()"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.ValidFrom)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.ValidFrom)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.validFrom"
                        languageKey="FEATURES.AGREEMENTS.VALIDFROM"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="commitmentPeriodTypeId"
                        >{{ 'FEATURES.AGREEMENTS.COMMITMENT_PERIOD' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.Period"
                    /></label>
                    <app-dropdown
                        [items]="commitmentperiodtypes$ | async"
                        formControlName="commitmentPeriodTypeId"
                        (ngModelChange)="commitmentPeriodChanged($event)"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.Period)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.Period)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.commitmentPeriodTypeId"
                        languageKey="FEATURES.AGREEMENTS.COMMITMENT_PERIOD"
                    />
                </app-form-group>
                <app-form-group *ngIf="showValidTo()">
                    <label for="validTo">
                        {{ 'FEATURES.AGREEMENTS.VALIDTO' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.ValidTo" />
                        <span
                            *ngIf="!isNotInventory()"
                            [appTooltip]="'FEATURES.AGREEMENTS.TOOLTIPS.INVENTORY_VALIDTO' | translate"
                            class="material-symbols-rounded"
                            aria-hidden="true"
                        >
                            help
                        </span>
                    </label>
                    <app-date-picker
                        [readonly]="validToIsReadOnly()"
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        formControlName="validTo"
                        [highlightAnimated]="isFieldHighlighted(agreementMetaDataConstants.ValidTo)"
                        (highlightFocus)="onFieldFocus(agreementMetaDataConstants.ValidTo)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.validTo"
                        languageKey="FEATURES.AGREEMENTS.VALIDTO"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="isNotInventory()">
                <app-form-group>
                    <label for="noticePeriod"
                        >{{ 'FEATURES.AGREEMENTS.NOTICE_PERIOD' | translate }} {{ lastDateForNotice }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.NoticePeriod"
                    /></label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="noticePeriod"
                        formControlName="noticePeriod"
                        type="number"
                        min="0"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.NoticePeriod)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.NoticePeriod)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.noticePeriod"
                        languageKey="FEATURES.AGREEMENTS.NOTICE_PERIOD"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="noticePeriodTypeId">&nbsp;</label>
                    <app-dropdown [items]="periodTypes" formControlName="noticePeriodTypeId" />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.noticePeriodTypeId"
                        languageKey="FEATURES.AGREEMENTS.NOTICE_PERIOD"
                    />
                </app-form-group>
            </app-form-row>

            <app-form-row *ngIf="isNotInventory() && showValidTo()">
                <app-form-group>
                    <label for="periodAfterExtension"
                        >{{ 'FEATURES.AGREEMENTS.COMMITMENT_PERIOD_AFTER_EXTENSION' | translate }}
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.PeriodAfterExtension"
                    /></label>
                    <input
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="periodAfterExtension"
                        formControlName="periodAfterExtension"
                        type="number"
                        min="0"
                        [ngClass]="{
                            'highlight-animated': isFieldHighlighted(agreementMetaDataConstants.PeriodAfterExtension)
                        }"
                        (focus)="onFieldFocus(agreementMetaDataConstants.PeriodAfterExtension)"
                    />
                    <app-validation-message
                        *ngIf="showPotentialValidationMessages"
                        [control]="f.periodAfterExtension"
                        languageKey="FEATURES.AGREEMENTS.COMMITMENT_PERIOD_AFTER_EXTENSION"
                    />
                </app-form-group>
                <app-form-group>
                    <label for="periodTypeIdAfterExtension">&nbsp;</label>
                    <app-dropdown [items]="periodTypes" formControlName="periodTypeIdAfterExtension" />
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="isNotInventory() && showValidTo()" class="align-bottom">
                <app-form-group>
                    <label for="noticePeriodAfterExtension"
                        ><app-checkbox
                            [text]="'FEATURES.AGREEMENTS.NOTICE_PERIOD_AFTER_EXTENSION' | translate"
                            (change)="toggleNoticePeriodAfterExtension()"
                            [checked]="f.noticePeriodAfterExtension.value > 0"
                            [disabled]="periodForm.disabled"
                        />
                        <app-pdf-reference-icon [fieldName]="agreementMetaDataConstants.NoticePeriodAfterExtension" />
                    </label>

                    <div *ngIf="f.noticePeriodAfterExtension.value > 0">
                        <input
                            appInputValidator
                            [checkValidity]="showPotentialValidationMessages"
                            id="noticePeriodAfterExtension"
                            formControlName="noticePeriodAfterExtension"
                            type="number"
                            min="0"
                            [ngClass]="{
                                'highlight-animated': isFieldHighlighted(
                                    agreementMetaDataConstants.NoticePeriodAfterExtension
                                )
                            }"
                            (focus)="onFieldFocus(agreementMetaDataConstants.NoticePeriodAfterExtension)"
                        />
                    </div>
                </app-form-group>
                <app-form-group *ngIf="f.noticePeriodAfterExtension.value > 0">
                    <label for="noticePeriodTypeIdAfterExtension">&nbsp;</label>
                    <app-dropdown [items]="periodTypes" formControlName="noticePeriodTypeIdAfterExtension" />
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
<form>
    <app-form-section [formGroup]="periodForm">
        <app-form-row-header
            [title]="
                (isInventoryType
                    ? 'FEATURES.AGREEMENTS.GROUP_TITLE_RETURN_MANAGE'
                    : 'FEATURES.AGREEMENTS.GROUP_TITLE_END_MANAGE'
                ) | translate
            "
            icon="calendar_today"
        />

        <div class="form">
            <app-form-row>
                <app-checkbox
                    [text]="
                        (isInventoryType ? 'FEATURES.AGREEMENTS.INVENTORY_RETURNED' : 'FEATURES.AGREEMENTS.TERMINATED')
                            | translate
                    "
                    (change)="toggleTerminated()"
                    [checked]="isTerminated"
                    [disabled]="periodForm.disabled"
                />
                <app-checkbox
                    [text]="'FEATURES.AGREEMENTS.TERMINATED_AND_REPLACED' | translate"
                    (change)="toggleTerminateAndReplace()"
                    [checked]="isTerminatedAndReplaced"
                    [disabled]="periodForm.disabled"
                />
                <app-checkbox
                    [text]="'FEATURES.AGREEMENTS.MANAGED' | translate"
                    (change)="toggleManaged()"
                    [checked]="isManaged"
                    [disabled]="periodForm.disabled"
                />
            </app-form-row>

            <app-form-row *ngIf="isTerminated || isTerminatedAndReplaced">
                <app-form-group>
                    <label for="terminationDate">{{
                        (isInventoryType
                            ? 'FEATURES.AGREEMENTS.INVENTORY_RETURNED'
                            : 'FEATURES.AGREEMENTS.TERMINATION_DATE'
                        ) | translate
                    }}</label>
                    <app-date-picker
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        formControlName="terminationDate"
                    />
                </app-form-group>
                <app-form-group>
                    <ng-container *ngIf="isNotInventory()">
                        <label for="expiryDateAfterTermination">{{
                            'FEATURES.AGREEMENTS.EXPIRY_DATE_AFTER_TERMINATION' | translate
                        }}</label>
                        <app-date-picker
                            appInputValidator
                            [checkValidity]="showPotentialValidationMessages"
                            formControlName="expiryDateAfterTermination"
                        />
                    </ng-container>
                </app-form-group>
                <app-form-group *ngIf="isTerminatedAndReplaced && !f.replacedByAgreementName.value">
                    <label for="replacedByAgreementId">&nbsp;</label>
                    <button (click)="goToCreateNewAgreement()" type="button" class="primary">
                        <span>{{ 'FEATURES.AGREEMENTS.REPLACED_BY' | translate }}</span>
                    </button>
                </app-form-group>

                <app-form-group *ngIf="f.replacedByAgreementName.value">
                    <label for="replacedByAgreementId">{{ 'FEATURES.AGREEMENTS.REPLACED_BY' | translate }}</label>
                    <div>
                        <a
                            class="replaced-agreement-link"
                            (click)="goToReplacedAgreement()"
                            (keypress)="goToReplacedAgreement()"
                            tabindex="0"
                        >
                            {{ f.replacedByAgreementName.value }}
                        </a>
                    </div>
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="isManaged">
                <app-form-group>
                    <label for="managedDate">{{ 'FEATURES.AGREEMENTS.MANAGED_DATE' | translate }}</label>
                    <app-date-picker
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        formControlName="managedDate"
                    />
                </app-form-group>
            </app-form-row>
            <app-form-row *ngIf="isManaged">
                <app-form-group>
                    <label for="managedNote">{{ 'FEATURES.AGREEMENTS.MANAGED_NOTE' | translate }}</label>
                    <textarea
                        class="managed-note-group"
                        appInputValidator
                        [checkValidity]="showPotentialValidationMessages"
                        id="managedNote"
                        formControlName="managedNote"
                        rows="3"
                        [placeholder]="'FEATURES.AGREEMENTS.MANAGED_NOTE_PLACEHOLDER' | translate"
                    >
                    </textarea>
                </app-form-group>
            </app-form-row>
        </div>
    </app-form-section>
</form>
